import React from 'react';
import { Routes, Route } from "react-router-dom";
import {Home} from "./components/home/home";
import {NotAuthorized} from "./components/notAuthorized";
import {Vehicle} from "./components/vehicle/vehicle";

export function App() {
    return (
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/:subdomain/vehicle/:objectId/:token" element={<Vehicle />} />
            <Route path="/:subdomain/:objectType/:objectId/:token" element={<Home />} />
            <Route path="/notAuthorized" element={<NotAuthorized />} />
        </Routes>
    );
}
